import { createGlobalStyle } from "styled-components";

export const theme = {
  colors: {
    primary: "#FE724C",
    onPrimary: "#FFFF",
    secondary: "#FE724C",
    onSecondary: "#FE724C",
    green: "#5CB891",
    yellow: "#F1C21B",
    grey: "#F1F2F3",
    tertiary: "rgb(128, 81, 88)",
    onTertiary: "rgb(255, 255, 255)",
    tertiaryContainer: "rgb(255, 217, 221)",
    onTertiaryContainer: "rgb(50, 16, 23)",
    error: "rgb(186, 26, 26)",
    onError: "rgb(255, 255, 255)",
    errorContainer: "rgb(255, 218, 214)",
    onErrorContainer: "rgb(65, 0, 2)",
    background: "rgb(255, 255, 255)",
    surfaceVariant: "rgb(233, 223, 235)",
    onSurfaceVariant: "rgb(74, 69, 78)",
    outline: "rgb(124, 117, 126)",
    outlineVariant: "rgb(204, 196, 206)",
    shadow: "rgb(0, 0, 0)",
    scrim: "rgb(0, 0, 0)",
    inverseSurface: "rgb(50, 47, 51)",
    inverseOnSurface: "rgb(245, 239, 244)",
    inversePrimary: "rgb(220, 184, 255)",
    elevation: {
      level0: "transparent",
      level1: "rgb(255, 255, 255)",
      level2: "rgb(255, 255, 255)",
      level3: "rgb(255, 255, 255)",
      level4: "rgb(255, 255, 255)",
      level5: "rgb(255, 255, 255)",
    },
    surfaceDisabled: "rgba(29, 27, 30, 0.12)",
    onSurfaceDisabled: "rgba(29, 27, 30, 0.38)",
    backdrop: "rgba(51, 47, 55, 0.4)",
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
  },
  textSize: {
    values: {
      title1: "34px",
      title2: "28px",
      subTitle: "22px",
      btnTextSize: "20px",
      description: "18px",
      smallText: "14px",
    },
  },
};

// GlobalStyle for applying theme globally
export const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${theme.colors.background};
    color: ${theme.colors.onSurfaceVariant};
    font-family: 'Arial', sans-serif;
    margin: 0;
  }

  h1 {
    font-size: ${theme.textSize.values.title1};
    color: ${theme.colors.primary};
  }

  h2 {
    font-size: ${theme.textSize.values.title2};
  }

  p {
    font-size: ${theme.textSize.values.description};
    color: ${theme.colors.onSurfaceVariant};
  }

  button {
    font-size: ${theme.textSize.values.btnTextSize};
    background-color: ${theme.colors.primary};
    color: ${theme.colors.onPrimary};
    padding: 10px 20px;
    border: none;
    cursor: pointer;
  }

  button:hover {
    background-color: ${theme.colors.secondary};
  }
`;

export const ayeTexts = {
  place_your_face: "Please place your face within the frame",
  welcome_screen: {
    header: "Let's Get Started",
    message:
      "Set up your device using the provided credentials and enjoy a seamless payment experience with just your face",
    button: "Get Started",
  },
  setup_screen: {
    header: "Set up your device",
    message:
      "Enter your credentials to set up your account, and your device will be ready for use.",
    invalid_email_address: "Invalid Email address",
    invalid_store_id: "Invalid Store ID",
    invalid_device_id: "Invalid Device ID",
    invalid_password: "Invalid password length",
  },
  greetings_screen: {
    button: "Start",
    header: "Greetings!",
    message: (deviceId: string) =>
      `Your device has been successfully set up with the assigned ID ${deviceId}. Ready to use and enjoy!`,
    submessage: "Ready to welcome your customers with a smile!",
  },
  face_detection: {
    default: "Validating face data",
    center_face: "Please center your face",
    move_closer: "Please move closer",
    move_farther: "Please move away further",
    stay_still: "Hold that perfect pose!",
    blink: "Blink your eyes",
    failed: "Oops! We couldn't recognize you. Please reposition and try again.",
    face_detected_message: "We have something interesting for you",
    eyes_open: "Look at the camera",
    ok_button: "Ok, let’s check it",
    no_button: "No, thanks",
  },
  suggestions_screen: {
    header: "Order Suggestion",
    message:
      "Remember these dishes and drinks you relished before? Would you like to order any of them again?",
    order_items_header: "Suggested items",
    add_items_message: "You want to add more items?",
    order_button: "Place Order",
    cancel_button: "Not Interested",
  },
  orders_screen: {
    items_header: "Order Summary",
    pay_button: "Pay Now",
    cancel_button: "Cancel",
  },
  success_screen: {
    top_section_header: "Success!",
    bottom_section_message:
      "Your transaction is successful, and your order is confirmed.",
    bottom_section_greeting: "Thank you for choosing our service",
  },
  failed_screen: {
    top_section_header: "Something went wrong!",
    bottom_section_message:
      "Your order D120923000038943 has been submitted, but we couldn't complete the transaction.",
    bottom_section_info:
      "Feel free to retry or finalize your payment at the cashier.",
    try_again_button: "Try Again",
    cancel_button: "Cancel",
  },
  registration_success: {
    ars: "You may now proceed to enter the store by showing your face when the screen returns to the home page",
    store: "You can now pay with just your face at any outlet with AyeFace",
  },
};

export const ayeColors = {
  spinner_orange: "#FDBA0F",
  spinner_yellow: "#F1C21B",
  spinner_green: "#4CD964",
};

export const colors = {
  main: "#FE724C",
  green: "#5CB891",
};
